import { DefaultUrlSerializer, UrlSerializer, UrlTree } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { inject, Injectable } from "@angular/core";

@Injectable()
export class LocalizedUrlSerializer implements UrlSerializer {
  private defaultSerializer = new DefaultUrlSerializer();
  private transloco = inject(TranslocoService);

  parse(url: string): UrlTree {
    return this.defaultSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    const lang = this.transloco.getActiveLang();
    let serialized = this.defaultSerializer.serialize(tree);

    if (
      serialized.match(/^\/(en|de|fr|es|pl)(\/|$)/) ||
      serialized.startsWith("http") ||
      serialized.startsWith("//")
    ) {
      return serialized;
    }

    if (serialized.startsWith("/blog")) {
      return `/en${serialized}`;
    }

    serialized = serialized.startsWith("/") ? serialized : `/${serialized}`;
    return `/${lang}${serialized}`;
  }
}
